import { Stack } from "@mui/material";
import TextField from "components/common/TextField";
import { GRID_SPACING } from "config";
import * as labels from "config.labels";
import { EMPTY_ADDRESS_COMPONENTS } from "domain/address";
import { useTranslator } from "store/hooks/staticDataHooks";

/**
 * Structured address inputs (street / street2 / city / state / zip) for a person.
 * Controlled: `components` holds the current values and `onChange` receives the full
 * updated components object. Uses the shared TextField + Stack layout so it aligns with
 * surrounding form fields.
 */
const PersonAddressComponents = ({ components, onChange }) => {
  const translateLabel = useTranslator("uiLabels");
  const current = components || EMPTY_ADDRESS_COMPONENTS;

  const update = (field) => (e) =>
    onChange({ ...current, [field]: e.target.value });

  return (
    <Stack spacing={GRID_SPACING}>
      <TextField
        label={translateLabel(labels.PERSON_ADDRESS_STREET_LABEL, {
          default: "Address Line 1",
        })}
        value={current.street ?? ""}
        onChange={update("street")}
      />
      <TextField
        label={translateLabel(labels.PERSON_ADDRESS_STREET2_LABEL, {
          default: "Address Line 2",
        })}
        value={current.street2 ?? ""}
        onChange={update("street2")}
      />
      <Stack direction={"row"} spacing={GRID_SPACING}>
        <TextField
          sx={{ flex: 5 }}
          label={translateLabel(labels.PERSON_ADDRESS_CITY_LABEL, {
            default: "City",
          })}
          value={current.city ?? ""}
          onChange={update("city")}
        />
        <TextField
          sx={{ flex: 3 }}
          label={translateLabel(labels.PERSON_ADDRESS_STATE_LABEL, {
            default: "State",
          })}
          value={current.state ?? ""}
          onChange={update("state")}
        />
        <TextField
          sx={{ flex: 4 }}
          label={translateLabel(labels.PERSON_ADDRESS_ZIP_LABEL, {
            default: "Zip Code",
          })}
          value={current.zip ?? ""}
          onChange={update("zip")}
        />
      </Stack>
    </Stack>
  );
};

export default PersonAddressComponents;
